import { render } from "./PrintDish.vue?vue&type=template&id=7574f674&scoped=true"
import script from "./PrintDish.vue?vue&type=script&lang=js"
export * from "./PrintDish.vue?vue&type=script&lang=js"

import "./PrintDish.vue?vue&type=style&index=0&id=7574f674&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7574f674"]])

export default __exports__